import { WebsitePagesState } from 'src/editor/store/website-pages/website-pages-reducer'

export const getIsPreviewMode = (state: WebsitePagesState) =>
  state.isPreviewMode

export const websitePagesSelectors = {
  getIsPreviewMode,
}
